// The non-word, non-dot boundary skips email local-parts like `me@taizo.com`,
// and mirrors the server-side bolding boundary in RemarksHelper#render_markdown.
// A pattern string (not a shared /g RegExp) so each call site gets its own
// lastIndex.
export const MENTION_PATTERN = '(?<![\\w.])@([a-z\\d-]+)'

// @external and @everyone notify Pulse users implicitly, so they warn too.
export const PULSE_MENTION_KEYWORDS = ['external', 'everyone']

export interface MentionMatch {
  index: number
  length: number
  name: string
}

export const normalizeMentionNames = (names: string[]): Set<string> =>
  new Set(names.map((name) => name.toLowerCase()))

const MENTION_REGEX = new RegExp(MENTION_PATTERN, 'gi')

export const findMentionMatches = (
  text: string,
  known: Set<string>
): MentionMatch[] => {
  if (!text || known.size === 0) return []

  const matches: MentionMatch[] = []

  // exec-loop, not matchAll: the iterator spread is mishandled by the test transform.
  MENTION_REGEX.lastIndex = 0
  let match: RegExpExecArray | null
  while ((match = MENTION_REGEX.exec(text)) !== null) {
    const name = match[1].toLowerCase()
    if (known.has(name)) {
      matches.push({ index: match.index, length: match[0].length, name })
    }
  }

  return matches
}

// String#match, not matchAll: the iterator spread is mishandled by the test transform.
export const scanMentionNames = (text: string): string[] => {
  if (!text) return []
  const matches = text.match(new RegExp(MENTION_PATTERN, 'gi')) ?? []
  return matches.map((mention) => mention.slice(1).toLowerCase())
}

export const isPulseWarningMention = (
  name: string,
  pulseUsernames: string[],
  pulseWarningActive: boolean
): boolean => {
  if (!pulseWarningActive || pulseUsernames.length === 0) return false

  const lower = name.toLowerCase()
  return (
    PULSE_MENTION_KEYWORDS.includes(lower) ||
    pulseUsernames.some((username) => username.toLowerCase() === lower)
  )
}
